// extracted by mini-css-extract-plugin
export default {"longWidget":"Dashboard_longWidget__GzCQO","longWidgetProduct":"Dashboard_longWidgetProduct__bTISw","smallWidget":"Dashboard_smallWidget__2xWvq"};